export default __webpack_public_path__ + "static/media/pc_video_bg.da80a7d2.jpg";